export const isApplePlatform = (() => {
  const ua = window.navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  // iPadOS 13+ reports as Mac; distinguish by touch support
  if (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) return true;
  if (/Mac OS X/.test(ua)) return true;
  return false;
})();
